module.exports = __webpack_public_path__ + "img/thema_info.b8f77a44.png";